import React from 'react';
import 'CSS/demand-supply/demand-supply.scss';
import 'CSS/dashboard-statistic.scss';
import 'CSS/dashboard-tickets.scss';
import 'CSS/dashboard-slips.scss';
import Grid from '@material-ui/core/Grid';

import { CheckListCriteria } from './components/CheckListCriteria';

export const CheckList = props => {
  return (
    <Grid container spacing={0} className={'u-pad-bot-10'}>
      {/*{filteredCriteria.map(primaryCriteria => (*/}
      {props.mainCriteria.map(key => {
        return (
          <Grid container spacing={0} key={key}>
            <Grid
              item
              // lg={4}
              // md={6}
              xs={6}
              className="u-pad-8"
            >
              <h2 className="t-primary-16 t-weight-b u-mrg-bot-10 u-mrg-top-10">
                {props.criteria[key].name}
              </h2>
            </Grid>
            <Grid container spacing={16}>
              {props.criteria[key].criteria.map(key1 => (
                <CheckListCriteria
                  key={key1}
                  currentCriteria={props.criteria[key1]}
                  criteria={props.criteria}
                />
              ))}
            </Grid>
          </Grid>
        );
      })}
      {/* ))} */}
    </Grid>
  );
};
